import { render, staticRenderFns } from "./accessory.vue?vue&type=template&id=708c38c8&"
import script from "./accessory.vue?vue&type=script&lang=js&"
export * from "./accessory.vue?vue&type=script&lang=js&"
import style0 from "./accessory.vue?vue&type=style&index=0&id=708c38c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports